import { ReactElement } from 'react';

import { GoToPatientsFileDropdownItem } from '~legacy.patient';

import { prescriptionVisitsTranslationKeys } from '../../../../translations';

type PatientFileDropdownItemProps = {
   readonly patientId: number;
};

export const PatientFileDropdownItem = (props: PatientFileDropdownItemProps): ReactElement => {
   return (
      <GoToPatientsFileDropdownItem
         patientId={props.patientId}
         addToStack={false}
         locationState={{
            label: prescriptionVisitsTranslationKeys.goBackToPrescriptionVisits,
         }}
      />
   );
};
